import { useSelector } from 'react-redux'

// TODO: Move to auth duck
const useAuth = () => useSelector(({ auth }) => auth || {})

export default useAuth
